import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Props:
 * - i18nKey: translation key (string)
 * - highlights: { [placeholder: string]: JSX.Element }
 */
const HighlightedText = ({ i18nKey, highlights = {} }) => {
  const { t } = useTranslation();

  // Replace placeholders with identifiable markers
  const placeholderMap = Object.keys(highlights).reduce((acc, key) => {
    acc[key] = `%%${key}%%`;
    return acc;
  }, {});

  const rawText = t(i18nKey, placeholderMap);

  // Build regex to split by all placeholder markers
  const splitRegex = new RegExp(`(${Object.values(placeholderMap).join("|")})`, "g");

  const parts = rawText.split(splitRegex);

  return (
    <span>
      {parts.map((part, idx) => {
        const match = Object.entries(placeholderMap).find(([, marker]) => part === marker);
        if (match) {
          const [key] = match;
          return React.cloneElement(highlights[key], { key: idx });
        }
        return <span key={idx}>{part}</span>;
      })}
    </span>
  );
};

export default HighlightedText;
